import { GetterTree } from 'vuex';
import { IProjectState } from './types';
import { IRootState } from '../types';
import { IProject } from '~/types/project';

export const getters: GetterTree<IProjectState, IRootState> = {
  getProjectBySlug: (state) => (projectSlug: string) => {
    const project: IProject | undefined = state.projects[projectSlug];
    return project;
  },
};
